<template>
    <div style="width: 100vw;height: auto;background-color: black;color: #fff;">
      <table style="width: 100vw;font-size: 0.8rem;font-family:'JDZY' ;">
      
        <tr>
          <td></td>
          <td style="color: #c8c8c8;line-height: 10px;padding-left: 13rem;">
            <div class="jinj"></div>
            <span> <i class="el-icon-message"></i>Email:</span> mkt@langsi-iot.com
            <div class="jinj"></div>
            <span> <i class="el-icon-phone"></i>Telephone:</span>(+)86-13806055501(Celeste Wong)
            <div class="jinj"></div>
            <span><i class="el-icon-location-outline"></i>Address:</span> 3F, No.226, Gaoqi South 5th Road, Huli District,Xiamen City, Fujian Province,China
            <div class="jinj"></div>
          </td>
          <td style="padding-right: 20px;float: right;margin-top: 3rem;">
            <div style="float: right;margin-right: 3rem;">
              <img style="width: 6rem;height: 3rem;float: right;margin-right: 4.5rem;" :src="logo1" alt="" srcset="" >
              <br>
              <span style="color: #c8c8c8;float: right;margin-top: 1.5rem;">Xiamen Langsi Intelligent Technology Co., Ltd</span>
            </div>
           
        
           
            
          </td>
          
        </tr>
        <tr>
         
          <td style="color: #fff;font-size: 10px;position: absolute;left: 50%;transform: translateX(-50%); " v-if="false" >
            © 2016-2021厦门朗思智能科技有限公司版权  &nbsp; &nbsp;&nbsp; &nbsp; 闽ICP备2021009698号-1&nbsp; &nbsp;&nbsp; &nbsp;闽公网安备 35020602002180号
          </td>
        </tr>
        <tr>
          <td></td>
         
          <td></td>
        </tr>
      </table>
       <!-- <div><img :src="logo1" alt="" srcset="" style="width: 120px;height: 40px;margin-left: 10px;">
       <div style="position: absolute;display: inline-block;"><span>全国热线</span>400-0592-008</div>
    </div> -->
      
    </div>
</template>
<script>
import logo1 from '../img/logo1.png'
import bgimg from '../img/bg.png'
import font from '../css/font.css'
export default {
  name: 'lk',//落款
  data() {
    return {
        logo1:logo1,
        bgimg:bgimg,
    }
   },
  components: {

  }
}
</script>
<style>
.jinj{
  height: 2rem;
}
</style>